  const marketSelectors = document.querySelectorAll(".market-selector-wrapper");
  if (marketSelectors.length === 0) return;

  marketSelectors.forEach(selector => {
    const currentMarketDisplay = selector.querySelector(".current-market-display");
    const marketOptionsList = selector.querySelector(".market-options-list");
    const marketOptions = selector.querySelectorAll(".market-option");

    const form = selector.querySelector('form');
    const languageInput = form?.querySelector('input[name="language_code"]');
    const countryInput = form?.querySelector('input[name="country_code"]');

    marketOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        if (form && languageInput && countryInput) {
          const marketIso = this.dataset.countryIso;
          const languageCode = this.dataset.languageIso;
          
          if (languageCode && marketIso) {
            languageInput.value = languageCode;
            countryInput.value = marketIso;
            form.submit();
          }
        }
      });
    });

    function openDropdown() {
      marketSelectors.forEach(otherSelector => {
        if (otherSelector !== selector) {
          const otherMarketOptionsList = otherSelector.querySelector(".market-options-list");
          const otherCurrentMarketDisplay = otherSelector.querySelector(".current-market-display");
          otherMarketOptionsList.classList.remove("show");
          otherCurrentMarketDisplay.classList.remove("active");
          otherCurrentMarketDisplay.setAttribute("aria-expanded", "false");
        }
      });

      marketOptionsList.classList.add("show");
      currentMarketDisplay.classList.add("active");
      currentMarketDisplay.setAttribute("aria-expanded", "true");

      if (marketOptions.length > 0) {
        const selectedOption = marketOptionsList.querySelector('.market-option.selected') || marketOptions[0];
        selectedOption.focus();
      }
    }

    function closeDropdown() {
      marketOptionsList.classList.remove("show");
      currentMarketDisplay.classList.remove("active");
      currentMarketDisplay.setAttribute("aria-expanded", "false");
      currentMarketDisplay.focus();
    }

    currentMarketDisplay.addEventListener("click", function () {
      if (marketOptionsList.classList.contains("show")) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    currentMarketDisplay.addEventListener("keydown", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (marketOptionsList.classList.contains("show")) {
          closeDropdown();
        } else {
          openDropdown();
        }
      } else if (e.key === 'ArrowDown' && !marketOptionsList.classList.contains("show")) {
        e.preventDefault();
        openDropdown();
      }
    });

    marketOptionsList.addEventListener("keydown", function (e) {
      const focusedOption = document.activeElement;
      if (!focusedOption || !focusedOption.classList.contains('market-option') || !marketOptionsList.contains(focusedOption)) {
        return;
      }

      const currentIndex = Array.from(marketOptions).indexOf(focusedOption);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (currentIndex < marketOptions.length - 1) {
          marketOptions[currentIndex + 1].focus();
        } else {
          marketOptions[0].focus();
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (currentIndex > 0) {
          marketOptions[currentIndex - 1].focus();
        } else {
          marketOptions[marketOptions.length - 1].focus();
        }
      }
    });

  });

  document.addEventListener("click", function (event) {
    marketSelectors.forEach(selector => {
      const currentMarketDisplay = selector.querySelector(".current-market-display");
      const marketOptionsList = selector.querySelector(".market-options-list");
      if (marketOptionsList.classList.contains("show") && !selector.contains(event.target)) {
        marketOptionsList.classList.remove("show");
        currentMarketDisplay.classList.remove("active");
        currentMarketDisplay.setAttribute("aria-expanded", "false");
      }
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === 'Escape') {
      marketSelectors.forEach(selector => {
        const currentMarketDisplay = selector.querySelector(".current-market-display");
        const marketOptionsList = selector.querySelector(".market-options-list");
        if (marketOptionsList.classList.contains("show")) {
          marketOptionsList.classList.remove("show");
          currentMarketDisplay.classList.remove("active");
          currentMarketDisplay.setAttribute("aria-expanded", "false");
          currentMarketDisplay.focus();
        }
      });
    }
  });